import { Box } from '@mui/material';
import { LineChart } from '@mui/x-charts';
import { ChartPoint } from 'services/Dashboard/types';

interface BarChartDayProps {
  data?: ChartPoint[];
}

const BarChartDay = ({ data = [] }: BarChartDayProps) => {
  const chartSetting = {
    // 'label' que vem do DTO (ex: "01", "02", etc)
    xAxis: [{ scaleType: 'point' as const, dataKey: 'label' }],
    width: 1100,
    height: 450,
    grid: { vertical: true, horizontal: true },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'var(--app-surface-2)',
        width: '100%',
        height: '100%',
        borderRadius: 3,
        boxShadow: '0 4px 24px rgba(0,0,0,0.25)',
        padding: { xs: 0, sm: 3 },
      }}
    >
      <LineChart
        dataset={data}
        series={[
          {
            dataKey: 'value', // Mapeia a propriedade 'value' do ChartPoint
            label: 'Eventos mensais',
          },
        ]}
        {...chartSetting}
      />
    </Box>
  );
};

export default BarChartDay;